// extracted by mini-css-extract-plugin
var _1 = "certificatesList-module_cell__mSlQUM";
var _2 = "certificatesList-module_flex_table__voHwJ6";
var _3 = "certificatesList-module_header__WYExQi";
var _4 = "certificatesList-module_row__W8XPrZ";
var _5 = "certificatesList-module_table__EIqMei";
var _6 = "certificatesList-module_table_container__lKI8Is";
export { _1 as "cell", _2 as "flex_table", _3 as "header", _4 as "row", _5 as "table", _6 as "table_container" }
